// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__uzBbv","closeButtonDark":"CloseButton_closeButtonDark__wf-AN"};